import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiTrendingUp, FiBook, FiBarChart2, FiCpu, FiSettings } = FiIcons

const BottomNav = () => {
  const location = useLocation()
  
  const navItems = [
    { path: '/dashboard', label: 'Home', icon: FiTrendingUp },
    { path: '/journal', label: 'Journal', icon: FiBook },
    { path: '/analytics', label: 'Stats', icon: FiBarChart2 },
    { path: '/insights', label: 'AI', icon: FiCpu },
    { path: '/settings', label: 'Settings', icon: FiSettings }
  ]

  return (
    <div className="fixed bottom-6 left-4 right-4 z-50 lg:hidden">
      <motion.div 
        className="bg-[#131b2e]/90 backdrop-blur-xl border border-white/10 rounded-3xl shadow-2xl shadow-black/50 px-2 py-2 flex justify-between items-center"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: 'spring', damping: 20, stiffness: 300 }}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path
          return (
            <Link 
              key={item.path} 
              to={item.path}
              className="relative flex flex-col items-center justify-center p-3 w-full"
            >
              {isActive && (
                <motion.div 
                  layoutId="bottom-nav-active"
                  className="absolute inset-0 bg-lux-primary/20 rounded-2xl"
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                />
              )}
              <motion.div
                animate={{ 
                  scale: isActive ? 1.1 : 1,
                  color: isActive ? '#3b82f6' : '#94a3b8'
                }}
                className="relative z-10"
              >
                <SafeIcon icon={item.icon} className={`h-6 w-6 ${isActive ? 'text-lux-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]' : 'text-gray-400'}`} />
              </motion.div>
            </Link>
          )
        })}
      </motion.div>
    </div>
  )
}

export default BottomNav